import * as ACTION from "./globalTriggerActionTypes";

export const addTriggerFolder = (payload) => ({
  type: ACTION.ADD_TRIGGER_FOLDER,
  payload: payload,
});

export const addTriggerFolderSuccess = (payload) => ({
  type: ACTION.ADD_TRIGGER_FOLDER_SUCCESS,
  payload: payload,
});
export const addTriggerFolderFailure = (payload) => ({
  type: ACTION.ADD_TRIGGER_FOLDER_FAILURE,
  payload: payload,
});

export const getTriggerFolder = (payload) => ({
  type: ACTION.GET_TRIGGER_FOLDER,
  payload: payload,
});

export const getTriggerFolderSuccess = (payload) => ({
  type: ACTION.GET_TRIGGER_FOLDER_SUCCESS,
  payload: payload,
});
export const getTriggerFolderFailure = (payload) => ({
  type: ACTION.GET_TRIGGER_FOLDER_FAILURE,
  payload: payload,
});

export const updateTriggerFolder = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_FOLDER,
  payload: payload,
});

export const updateTriggerFolderSuccess = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_FOLDER_SUCCESS,
  payload: payload,
});
export const updateTriggerFolderFailure = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_FOLDER_FAILURE,
  payload: payload,
});

export const deleteTriggerFolder = (payload) => ({
  type: ACTION.DELETE_TRIGGER_FOLDER,
  payload: payload,
});

export const deleteTriggerFolderSuccess = (payload) => ({
  type: ACTION.DELETE_TRIGGER_FOLDER_SUCCESS,
  payload: payload,
});
export const deleteTriggerFolderFailure = (payload) => ({
  type: ACTION.DELETE_TRIGGER_FOLDER_FAILURE,
  payload: payload,
});

export const handlePermissionDeniedModal = (payload) => ({
    type: ACTION.HANDLE_PERMISSION_DENIED_MODAL,
    payload: payload,
});

export const handleSelectedFolder = (payload) => ({
    type: ACTION.HANDLE_SELECTED_FOLDER,
    payload: payload,
});
export const handleTriggerPrivacyLevel = (payload) => ({
  type: ACTION.HANDLE_TRIGGER_PRIVACY_LEVEL,
  payload: payload,
});

export const handleTriggerSearch = (payload) => ({
  type: ACTION.HANDLE_TRIGGER_SEARCH,
  payload: payload,
});

export const handleUserWiseFilter = (payload) => ({
  type: ACTION.HANDLE_USER_WISE_FILTER,
  payload: payload,
});

export const addTrigger = (payload) => ({
  type: ACTION.ADD_TRIGGER,
  payload: payload,
});

export const addTriggerSuccess = (payload) => ({
  type: ACTION.ADD_TRIGGER_SUCCESS,
  payload: payload,
});
export const addTriggerFailure = (payload) => ({
  type: ACTION.ADD_TRIGGER_FAILURE,
  payload: payload,
});


export const getTrigger = (payload) => ({
  type: ACTION.GET_TRIGGER,
  payload: payload,
});

export const getTriggerSuccess = (payload) => ({
  type: ACTION.GET_TRIGGER_SUCCESS,
  payload: payload,
});
export const getTriggerFailure = (payload) => ({
  type: ACTION.GET_TRIGGER_FAILURE,
  payload: payload,
});

export const getTriggerMoreData = (payload) => ({
  type: ACTION.GET_TRIGGER_MORE_DATA,
  payload: payload,
});

export const recallTrigger = (payload) => ({
  type: ACTION.RECALL_TRIGGER,
  payload: payload,
});

export const updateTrigger = (payload) => ({
  type: ACTION.UPDATE_TRIGGER,
  payload: payload,
});

export const updateTriggerSuccess = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_SUCCESS,
  payload: payload,
});
export const updateTriggerFailure = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_FAILURE,
  payload: payload,
});

export const deleteTrigger = (payload) => ({
  type: ACTION.DELETE_INSURANCE_TRIGGER,
  payload: payload,
});

export const deleteTriggerSuccess = (payload) => ({
  type: ACTION.DELETE_INSURANCE_TRIGGER_SUCCESS,
  payload: payload,
});
export const deleteTriggerFailure = (payload) => ({
  type: ACTION.DELETE_INSURANCE_TRIGGER_FAILURE,
  payload: payload,
});

export const updateTriggerStatus = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_STATUS,
  payload: payload,
});

export const updateTriggerStatusSuccess = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_STATUS_SUCCESS,
  payload: payload,
});
export const updateTriggerStatusFailure = (payload) => ({
  type: ACTION.UPDATE_TRIGGER_STATUS_FAILURE,
  payload: payload,
});

export const duplicateTrigger = (payload) => ({
  type: ACTION.DUPLICATE_INSURANCE_TRIGGER,
  payload: payload,
});

export const duplicateTriggerSuccess = (payload) => ({
  type: ACTION.DUPLICATE_INSURANCE_TRIGGER_SUCCESS,
  payload: payload,
});

export const duplicateTriggerFailure = (payload) => ({
  type: ACTION.DUPLICATE_INSURANCE_TRIGGER_FAILURE,
  payload: payload,
});


